import {useEffect,useState} from "react";

const useOdliczanie = (cel,czas) => {
    const  startData = new Date(cel).getTime()
    const  endData   = startData + czas
    const [odliczanie,setOdliczanie] = useState (endData - startData)
    useEffect(() => {
        const interwal = setInterval(() => {setOdliczanie(endData - new Date().getTime())},1000)
        return () => clearInterval(interwal) 
     },[endData])
    return getReturnValues (odliczanie)
}
 const getReturnValues = (odliczanie) => {
    const min_sek  = 1000 * 60
    const godz_sek = min_sek * 60
    const dni_sek  = godz_sek * 24
    const dni = Math.floor(odliczanie/ dni_sek)
    const godziny = Math.floor((odliczanie % (dni_sek)) / godz_sek)
    const minuty = Math.floor((odliczanie% (godz_sek))/min_sek)
    const sekundy = Math.floor((odliczanie % (min_sek))/ 1000)
    return [dni,godziny,minuty,sekundy]
 }

 export { useOdliczanie}